import { VolumeBar } from "./VolumeBar";
import { MediumTextM, Space, VerticalFlex } from "@enxcs/dap-ui-stratos";
import { StatusIndicator } from "./StatusIndicator";
import { MicrophoneVolumeContainer } from "./MicrophoneTest.styles";
import { useTranslation } from "react-i18next";
import { useMicrophoneStatus } from "@/features/MicrophoneManager/hooks/useMicrophoneStatus";
import { useEffect } from "react";
import { MicrophoneStatusEnum, type MicrophoneStatus } from "@/types/microphoneStatus";

interface MicrophoneTestProps {
  stream: MediaStream | null;
  error: string | null;
  onMicrophoneStatusChange?(status: MicrophoneStatus): void;
}

export const MicrophoneTest = ({ stream, error, onMicrophoneStatusChange }: MicrophoneTestProps) => {
  const { t } = useTranslation();

  const { isActive, isMuted } = useMicrophoneStatus(stream, { subscribeVolume: false });

  useEffect(() => {
    onMicrophoneStatusChange?.(isActive ? MicrophoneStatusEnum.Active : MicrophoneStatusEnum.Inactive);
  }, [isActive, onMicrophoneStatusChange]);

  return (
    <VerticalFlex $gap={Space.V4}>
      <MicrophoneVolumeContainer $gap={Space.V12}>
        <StatusIndicator isActive={isActive} isMuted={isMuted} hasError={!!error} />

        <VerticalFlex $grow={true}>
          <VolumeBar stream={stream} />
        </VerticalFlex>
      </MicrophoneVolumeContainer>

      {!!error && <MediumTextM>{t(error)}</MediumTextM>}
    </VerticalFlex>
  );
};
